import React from 'react';
import { MessageSquare, Upload, Settings, Car } from 'lucide-react';
import { howItWorksSteps } from '../mockData';

const iconMap = {
  MessageSquare,
  Upload,
  Settings,
  Car
};

export const HowItWorks = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            So einfach <span className="text-blue-600">funktioniert es</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            In nur 4 Schritten zu Ihrer fertigen Zulassung – unkompliziert und schnell
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line (Desktop) */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-600 transform -translate-y-1/2 z-0" 
               style={{ top: '80px' }}>
          </div>

          {/* Steps Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative z-10">
            {howItWorksSteps.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              return (
                <div key={step.id} className="text-center">
                  {/* Step Number & Icon */}
                  <div className="relative inline-block mb-6">
                    <div className="w-32 h-32 bg-white border-4 border-blue-600 rounded-full flex items-center justify-center shadow-xl relative z-10">
                      <IconComponent className="w-12 h-12 text-blue-600" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                      {step.id}
                    </div>
                  </div>

                  {/* Step Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>

                  {/* Mobile Arrow */}
                  {index < howItWorksSteps.length - 1 && (
                    <div className="lg:hidden flex justify-center mt-6">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-blue-50 rounded-2xl px-8 py-6 border-2 border-blue-100">
            <p className="text-lg font-semibold text-gray-900 mb-2">
              Bereit für Ihre stressfreie Zulassung?
            </p>
            <p className="text-gray-600">
              Kontaktieren Sie uns jetzt und lassen Sie uns den Rest erledigen!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
